exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sau-readonly-display {\n  padding-top: 10px;\n  margin: 0;\n}\n.sau-readonly-display p {\n  padding-bottom: 10px;\n  margin: 0;\n  border-bottom: 1px solid #e5e5e5;\n}\n.sau-readonly-display:nth-last-child(-n + 2) p {\n  border: 0;\n}\n.sau-readonly-display h5 {\n  margin: 0;\n  padding: 0;\n}\n", ""]);

// exports
